/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Dialog_DescInputs */

const es_landing_dialog_desc = /** @type {(inputs: Landing_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fijas el precio por día, los mínimos de reserva, la cancelación y los extras. Lo que ve el cliente es lo que paga — y de ahí sale la comisión, siempre a la vista.`)
};

const gl_landing_dialog_desc = /** @type {(inputs: Landing_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixas o prezo por día, os mínimos de reserva, a cancelación e os extras. O que ve o cliente é o que paga — e de aí sae a comisión, sempre á vista.`)
};

const en_landing_dialog_desc = /** @type {(inputs: Landing_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You set the daily rate, minimum stay, cancellation and extras. What guests see is what they pay — and commission comes from that, always transparent.`)
};

/**
* | output |
* | --- |
* | "You set the daily rate, minimum stay, cancellation and extras. What guests see is what they pay — and commission comes from that, always transparent." |
*
* @param {Landing_Dialog_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_dialog_desc = /** @type {((inputs?: Landing_Dialog_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Dialog_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_dialog_desc(inputs)
	if (locale === "en") return en_landing_dialog_desc(inputs)
	return es_landing_dialog_desc(inputs)
});